// Navigation progress indicator - no-op in SPA
// toploader was a Next.js specific component

export function NavigationProgress() {
  return null;
}
